import React from 'react';
import Icon from '@components/atoms/Icon';
import Button from '@components/atoms/Button';
import { useCartContext } from './CartContext';

interface CartBodyHeaderProps {
  isCartPage: boolean;
  isCartEmpty: boolean;
}

const CartBodyHeader: React.FC<CartBodyHeaderProps> = ({ isCartPage, isCartEmpty }) => {
  const { cart } = useCartContext();

  return (
    <>
      {!isCartPage ? (
        <div className="p-5 flex items-center justify-between">
          <p className="flex items-center gap-4">
            {!isCartEmpty && (
              <>
                <span className="w-8 h-8 text-3xl flex items-center justify-center">✅</span>
                <span className="body-price">{window.DEPT.Strings.cart.addedToCart}</span>
              </>
            )}
          </p>
          <button
            className="cursor-pointer"
            type="button"
            aria-label="Close announcement"
            onClick={() => {
              const event = new CustomEvent('cart:close');
              document.dispatchEvent(event); // Trigger the close event for the Panel
            }}
          >
            <Icon name="close" className="text-black w-5 h-5" strokeWidth={2} />
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-between gap-5 flex-wrap mb-8 px-2.5 md:px-0">
          <h1 className="h1">{window.DEPT.Strings.cart.title}</h1>
          <Button
            mode="button"
            className="text-white min-w-40"
            buttonText="Share cart"
            icon="share-cart"
            iconClassName="mr-1.5"
            variant="secondary"
            onClick={() => cart.share()}
          />
        </div>
      )}
    </>
  );
};

export default CartBodyHeader;
